<template>
    <header id="header-container" class="fullwidth hidden-lg hidden-xl">

        <!-- Header -->
        <div id="header">
            <div class="container" style="width: 100%;">
                
                <!-- Left Side Content -->
                <div class="left-side">
                    
                    <div class="left-button hidden-xl" v-if="$router.currentRoute.meta.backButton">
                        <a v-on:click="$root.back()">
                            <i class="material-icons">arrow_back</i>
                        </a>
                    </div>

                    <span class="mmenu-trigger" v-if="!$router.currentRoute.meta.backButton">
                        <button class="hamburger hamburger--collapse" type="button">
                            <span class="hamburger-box">
                                <span class="hamburger-inner"></span>
                            </span>
                        </button>
                    </span>

                    <div id="logo">
                        <a>
                            {{$router.currentRoute.meta.title}}
                        </a>
                    </div>

                </div>


                <div class="right-side">

                    <!-- Main Navigation -->

                    <!-- Main Navigation / End -->

                </div>
                <!-- Right Side Content / End -->

            </div>
        </div>
        <!-- Header / End -->

    </header>
    <!-- <div class="clearfix"></div>     -->
</template>

<script>
export default {
    name: 'Top',
    data () {
        return {
            
        }
    },
    methods: {
             
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Top.vue